import apiUrl from '../../../constants'
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import VCalendar from 'v-calendar'
import PageTracker from '../../../common/PageTrackerHelper'
import {
  BasicSelect
} from 'vue-search-select';
import ForwardBulkPodResultStatus from '../common/ForwardBulkPodResultStatus'

const today = new Date();
export default {
  name: 'SetShipmentStatus',
  components: {
      VueElementLoading,
      VCalendar,
      BasicSelect,
      Paginate,
      'Forward-bulk-status' : ForwardBulkPodResultStatus
  },
  mixins:[PageTracker],
  data: function() {
      return {
        ShippingId:'',
        statusListObj:[],
        idProofListObj:[],
        disputeListObj:[],
        consigneeListObj:[],
        getHubObj:[],
        shippingDetailsShow:false,
        altCustomerDetailsShow:false,
        DeliveryStatus:'',
        DeliverySubStatus:'',
        ReceiverMobNo:'',
        ReceiverMobNoShow:false,
        ReceiverName:'',
        IsReceiverNameDisabled:false,
        NetPaymentReceived:'',
        Remarks:'',
        localusermailid:'',
        hubdetails:'',
        ClientId: '',
        OrderNo: '',
        OrderType:'',
        ProcessCode:'',
        UserProcess:'',
        DeliveryType:'',
        disputeDetailsShow:false,
        DisputeStatus:'',
        receiverTypeShow:false,
        ReceiverType:0,
        podMarkOnShow:false,
        PodMarkOnType:0,
        RelationWithConsigneeShow:false,
        RelationWithConsignee:'',
        IDProofListShow:false,
        IDProof:'',
        IDProofNo:'',
        reattemptDeliveryDateShow:false,
        IsOpenDelivery: '',
        isDeliveryTypeOpen:false,
        ClientBusinessDetailId:'',
        processCodeArr: {},
        dateobj : {
          "toDate" : '',
          "fromDate" : '',
          "DeliveryDate": new Date(),
          "DeliveryTime": '',
          "ReattemptDate": ''
        },
        AllowedNDRReasonsCodes: [],
        IsOpenDeliveryModal:false,
        DisputeComment: '',
        PODImage: '',
        PODImageShow: false,
        file : '',
        isLoadingPrint: false,
        PODPath: '',
        disablePrevDate: '',
        RunSheetId: '',
        nonVerifiedNDR: 'false',
        UserOTP: '',
        verifyOTPFlag: 'false',
        NdrOTPFlag: false,
        isShipmentOTP: false,
        isTripAllowedForSR: false,
        NDRSecurityCode: '',
        deliveryCodeVerify: '',
        isgetShipmentLoad: false,
        statusObj: {},
        IsAuthenticNDR: false,
        NDRCodeComments: '',
        allStatusList: [],
        MarkPod: 1,
        bulkShipmenttype: 'Delivery',
        CurrentUserAccessHubObj: {},
        bulkHubname: '',
        DeliveryUserList: [],
        srLoader: false,
        deliveryObj: {"text":"","value":""},
        deliverUserName: '',
        pageno: 1,
        perPage: 10,
        LatmileShipmentData: [],
        pagecount: 1,
        isBulkPodLoading: false,
        isBulkShipmentListLoading: false,
        selectedShipmentData: [],
        BulkDeliveryStatus: '',
        disputeListObj: {value:'',text: ''},
        BulkDisputeStatus: '',
        showForwardBulkReportStatus: {},
        isForwardBulkReportLoader: false,
        showForwardBulkModel: false,
        BulkUpdateFlag: 0,
        bulkDisputeDetailsShow: false,
        iswrongPincode: '',
        IsLongPinCode: true,
        BPPackageIDShow:false,
        BPackingID:'',
        DBBPackingID:'',
        BPobj:{},
        Ismannual : false,
        keyFiredCount: {'value':0},
        noofbpscansallowed:0,
        isAllowManualEntryBP:0,
        userDataKey : '',
      }
  },
  created: function() {
    this.changeDateFormat();
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);

    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.hubdetails = userdetail.hubdetails[0];
    console.log('CBU Value ----->>',await this.validateCrossBorderUser());
    let today = new Date();
    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    this.disablePrevDate = yesterday;
    //console.log('yesterday',new Date(yesterday));

    this.CurrentUserAccessHubObj = await this.getHubDetailsbyID(this.localuserid,this.hubdetails);
    this.bulkHubname = this.CurrentUserAccessHubObj.HubID;
    this.DeliveryUserList = await this.getHubDeliverySRList(this.hubdetails,true);
    //console.log('DeliveryUserList',this.DeliveryUserList);

    this.$watch(
      "$refs.childForwardComp.value",
      (new_value, old_value) => {
        this.showForwardBulkModel = new_value;
    });
  },
  watch: {
    MarkPod: {
       handler: async function(val){
        //console.log('markpod',val);
        this.bulkClear();
        this.resetForm();
      },
      deep: true
    },
    showForwardBulkModel: {
      handler: async function(val) {
        if( val == false){
          //console.log('false');
          this.showForwardBulkReportStatus = {};
          this.showForwardBulkModel = false;
          this.getShipmentList('noError');
        }
      },
      deep: true
    }
  },
  methods : {
    validateCrossBorderUser() {
      return new Promise((resolve, reject) => {
        try {
          var permissionEncrypt = window.localStorage.getItem('lmaccesspermissiondata')
          var bytes  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), this.userDataKey);
          var plaintext = bytes.toString(CryptoJS.enc.Utf8);
          let IsCrossBorderUser = plaintext.search("\"Crossborder Update\"");
          console.log('CBU Return ------------->>>', IsCrossBorderUser);
          if(IsCrossBorderUser != -1) {
            resolve(true)
          } else {
            resolve(false)
          }
        } catch(e) {
          resolve(false)
        }
      })
    },
    getdeliverySelect(obj){
      this.deliveryObj = obj;
      this.deliverUserName = obj.value;
    },
    getPaginationData(pageNum) {
      this.pageno = pageNum;
      this.GetShipmentDetails();
    },
    async getShipmentList(flag){
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.GetShipmentDetails(flag);

      let shipmentType = {
          ShipmentType: 'Forward',
          BusinessConfigurationId: 2
      };
      this.statusListObj = await this.GetStatusCode(shipmentType);
    },
    async BulkcheckStatusCode(){

      let statusId = this.BulkDeliveryStatus.toString();
      this.bulkDisputeDetailsShow = false;
      //console.log('statusid is',statusId);
      if (statusId == 'XBU00004' || statusId == 'XBU00023' || statusId == 'XBU00024' || statusId == 'XBU00327'){

         if(statusId == 'XBU00023') {
           this.processCodeArr = {
               processcode: 'P064'
           };
           this.NdrOTPFlag = false;
           this.verifyOTPFlag = 'true';
         } else if(statusId == 'XBU00024'){
           this.processCodeArr = {
               processcode: 'P048'
           };
           this.NdrOTPFlag = false;
           this.verifyOTPFlag = 'true';
         } else if(statusId == 'XBU00004' || statusId == 'XBU00327') {
           this.processCodeArr = {
               processcode: 'P071'
           };
         }
         //this.disputeListObj = await this.GetDisputeList(this.processCodeArr);
         this.bulkDisputeDetailsShow = true;
       }
      //end
    },
    selectAllShipments(ev) {
      this.selectedShipmentData = [];
      if (ev.target.checked == true) {
        for (let i in this.LatmileShipmentData) {
          // adding logic for select all maximum 20
          this.selectedShipmentData.push(
            this.LatmileShipmentData[i].ShippingID.toString()
          );
        }
      }
    },
    // setcheckbox(event) {
    //   if (event.target.checked == false) {
    //     this.selectedShipment1Data = false;
    //   }
    // },
    GetShipmentDetails(val = ''){
      //console.log('vvaa',val);
      this.isBulkPodLoading = true;
      this.isBulkShipmentListLoading = true;
      this.selectedShipmentData = [];
      this.LatmileShipmentData = [];
      let shipmentdataInput = {
        "ShipmentType": this.bulkShipmenttype,
        "HubId": this.bulkHubname,
        "DeliveryUserID": this.deliverUserName,
        "pageNo": this.pageno,
        "perPage": this.perPage,
        "clientId": ["60"]
      }

       axios
        .post(
          `${apiUrl.api_url}expose/web/get/shipmentdataformarkedwhhandover`,
          shipmentdataInput
        )
        .then(response => {
          //console.log('response.data.data.data',response);
          this.isBulkPodLoading = false;
          this.isBulkShipmentListLoading = false;
          if (response.data.code === 200 && response.data.data.data.length > 0) {
            this.BulkUpdateFlag = 1;
            this.LatmileShipmentData = response.data.data.data;
            let totalRows = response.data.data.total;
            //console.log('totalRows',totalRows);
            if (totalRows < this.perPage) {
               this.pagecount = 1
            } else {
               this.pagecount = Math.ceil(totalRows / this.perPage)
            }
            //console.log('pagecount',this.pagecount);
          } else {
            this.$alertify.error("Shipments not found");
            this.BulkUpdateFlag = 0;
          }
        })
        .catch(httpException => {
          if(val != 'noError'){
            this.$alertify.error("Data Not Found");
          }
          this.isBulkPodLoading = false;
          this.isBulkShipmentListLoading = false;
          console.error("exception is:::::::::", httpException);
        });
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        this.clear();
        if(result){
          this.isgetShipmentLoad = true;
          let data={
              ShippingID: this.ShippingId.trim(),
              shipmentType: 'delivery'
          };
          this.RunSheetId = '';
          axios.post(apiUrl.api_url + 'expose/get/shipment/details',data)
           .then(async (shipmentresult) => {
               if(shipmentresult.data.code===200){
                 this.AllowedNDRReasonsCodes = []
                 let current_datetime = new Date()
                 this.dateobj.DeliveryTime = moment(current_datetime).format('HH:mm');
                 if(shipmentresult.data.data.CurrentHubID !== this.hubdetails) {
                   this.getHubObj=[];
                   this.$alertify.error("Shipment belongs to other hub.");
                   this.shippingDetailsShow = false;
                 } else {
                   if(shipmentresult.data.data.OTP != '' && shipmentresult.data.data.OTP != 'null' && shipmentresult.data.data.OTP != null && shipmentresult.data.data.OTP != 'undefined'){
                     this.NdrOTPFlag = true;
                     this.isShipmentOTP = true;
                   } else {
                     this.NdrOTPFlag = false;
                     this.verifyOTPFlag = 'true';
                     this.isShipmentOTP = false;
                   }
                   let shipmentdata={
                       ShippingId: this.ShippingId.trim()
                   };

                   this.ClientId = shipmentresult.data.data.ClientId;
                   this.OrderNo = shipmentresult.data.data.OrderNo;
                   this.OrderType = shipmentresult.data.data.OrderType;
                   this.ProcessCode = shipmentresult.data.data.ProcessCode;
                   this.UserProcess = shipmentresult.data.data.UserProcess;
                   this.DeliveryType = shipmentresult.data.data.DeliveryType;
                   this.IsOpenDelivery = shipmentresult.data.data.IsOpenDelivery;
                   this.ClientBusinessDetailId = shipmentresult.data.data.ClientBusinessDetailId;
                   this.RunSheetId = shipmentresult.data.data.RunSheetId;
                   this.ShipmentOTP =  shipmentresult.data.data.OTP;
                   this.IsLongPinCode =  shipmentresult.data.data.IsLongPinCode;
                   if(shipmentresult.data.data.AllowedNDRReasonsCodes != '' && shipmentresult.data.data.AllowedNDRReasonsCodes != null){
                     let reasonCodes = shipmentresult.data.data.AllowedNDRReasonsCodes;
                     this.AllowedNDRReasonsCodes = reasonCodes.split(',');
                   }
                   if(this.OrderType == 'COD'){
                     this.NetPaymentReceived = (shipmentresult.data.data.Amount) ? shipmentresult.data.data.Amount : '';
                   }
                   this.isTripAllowedForSR = shipmentresult.data.data.isTripAllowedForSR;
                   this.NDRSecurityCode = shipmentresult.data.data.NDRSecurityCode;
                   //this.getHubObj = shipmentresult.data.data;
                   // axios.post(apiUrl.api_url + 'expose/shipment/get/allocated/srdetails/by/shippingid',shipmentdata)
                   //  .then((response) => {
                    if(shipmentresult.data.data.BPPackageID && shipmentresult.data.data.BPPackageID != null){
                      this.BPPackageIDShow = true;
                      this.DBBPackingID = shipmentresult.data.data.BPPackageID;
                      this.noofbpscansallowed = shipmentresult.data.data.noofbpscansallowed;
                      this.isAllowManualEntryBP = shipmentresult.data.data.isAllowManualEntryBP;
                    }
                    else{
                      this.BPPackageIDShow = false;
                    }
                   if(shipmentresult.data.data.DeliveryUserId != '' && shipmentresult.data.data.DeliveryUserId != null){
                      this.shippingDetailsShow = true;
                        this.getHubObj ={
                          'ShippId':shipmentresult.data.data.ShippingID,
                          'ShipName':shipmentresult.data.data.CustomerName,
                          'ShipAddress':shipmentresult.data.data.IsRedirect == true ? shipmentresult.data.data.AlternateAddress : shipmentresult.data.data.CustomerAddress,
                          'ShipCity':shipmentresult.data.data.IsRedirect == true ?  shipmentresult.data.data.CustAltCity : shipmentresult.data.data.ShipCity,
                          'ShipState':shipmentresult.data.data.IsRedirect == true ? shipmentresult.data.data.CustAltState : shipmentresult.data.data.ShipState,
                          'ShipPinCode':shipmentresult.data.data.IsRedirect == true ? shipmentresult.data.data.CustAltPinCode : shipmentresult.data.data.ShipPincode,
                          'ShipMobileNo':shipmentresult.data.data.IsRedirect == true ? shipmentresult.data.data.AltMobileNumber: shipmentresult.data.data.MobileNumber,
                          'ShipAltAddress':shipmentresult.data.data.AlternateAddress,
                          'ShipAltPinCode':shipmentresult.data.data.CustAltPinCode,
                          'ShipAltMobileNo':shipmentresult.data.data.AltMobileNumber,
                          'NetPayment':shipmentresult.data.data.Amount,
                          'OrderType':shipmentresult.data.data.OrderType,
                          'ShipmentStatus':shipmentresult.data.data.ShipmentStatus,
                          'DeliveryStatus':shipmentresult.data.data.Status,
                          'DeliveryUsername':shipmentresult.data.data.DeliveryUserName,
                          'DeliveryUserID':shipmentresult.data.data.DeliveryUserId,
                          'MobileNo':shipmentresult.data.data.DeliveryUserMobileNo,
                          'ShipmentType': shipmentresult.data.data.ShipmentType,
                        }

                        let shipmentType = {
                            ShipmentType: 'Forward',
                            BusinessConfigurationId:shipmentresult.data.data.ClientBusinessConfigration
                        };

                        let statusCodeList = await this.GetStatusCode(shipmentType); 

                        if (this.DBBPackingID == null || this.DBBPackingID == '') {
                       statusCodeList = statusCodeList.filter(element => element.uniquecode != 'XBU00851');
                     }
                        //console.log('statusCodeList',statusCodeList);
                        let This = this;
                        statusCodeList.forEach(function(obj) {
                          This.statusListObj.push({
                            'value': obj.uniquecode,
                            'text': `${obj.uniquecode} - ${obj.userprocess}`
                          })
                        })
                        //console.log('this.statusListObj',this.statusListObj);
                        let applictionType = {
                            ApplicableFor: 'Web'
                        };
                        this.idProofListObj = await this.GetIDProofList(applictionType);
                        //console.log('this.idProofListObj',this.idProofListObj);
                        // this.processCodeArr = {
                        //     processcode: 'P064'
                        // };
                        // this.disputeListObj = await this.GetDisputeList(this.processCodeArr);
                        //console.log('this.disputeListObj',this.disputeListObj);
                        let consigneePayload = {
                            DeliveryType: this.DeliveryType,
                            ClientBusinessDetailId: this.ClientBusinessDetailId
                        };
                        this.consigneeListObj = await this.GetConsigneeList(consigneePayload);
                        //console.log('this.consigneeListObj',this.consigneeListObj);
                    }
                    else {
                        this.getHubObj=[];
                        this.$alertify.error("shipment not allocated.");
                        this.shippingDetailsShow = false;
                    }
                    // })
                    // .catch((httpException) => {
                    //     this.$alertify.error("shipment data not found");
                    //     console.error('exception is:::::::::', httpException);
                    //     this.shippingDetailsShow = false;
                    // })
                  }
               }
               else {
                   this.getHubObj=[];
                   this.$alertify.error(shipmentresult.data.message);
                   this.shippingDetailsShow = false;
               }
              this.isgetShipmentLoad = false;
           })
           .catch((httpException) => {
               this.$alertify.error("shipment data not found");
               console.error('exception is:::::::::', httpException);
               this.shippingDetailsShow = false;
               this.isgetShipmentLoad = false;
           })
        }
      }).catch(() => {
        this.$alertify.error("shipment data not found");
        this.isgetShipmentLoad = false;
        console.log('errors exist', this.errors)
      });
    },
    VerifyNdrotpfeature(){
      if(this.UserOTP == ''){
        this.verifyOTPFlag = 'true';
        this.nonVerifiedNDR = 'true';
        this.IsAuthenticNDR = false;
        this.NDRCodeComments = 'Customer not willing to share the NDR code';
      } else {
        this.verifyOTPFlag = 'false';
      }
    },
    VerifyOTP(){
      if(this.UserOTP == ''){
        this.$alertify.error('Please Enter Code.!');
        this.$refs.UserOTP.focus()
        this.verifyOTPFlag = 'true';
        this.nonVerifiedNDR = 'true';
        this.IsAuthenticNDR = false;
        this.NDRCodeComments = 'Customer not willing to share the NDR code';
      }else if(this.UserOTP == this.ShipmentOTP) {
        this.$alertify.success('Code verified successfully.!');
        this.verifyOTPFlag = 'true';
        this.nonVerifiedNDR = 'false';
        this.IsAuthenticNDR = true;
        this.NDRCodeComments = '';
      } else {
        this.verifyOTPFlag = 'false';
        this.$alertify.error('Wrong Code, Please enter valid Code.!');
        this.nonVerifiedNDR = 'true';
        this.IsAuthenticNDR = false;
        this.NDRCodeComments = 'Customer not willing to share the NDR code';
      }
    },
    // checkboxVerify(e){
    //   this.UserOTP = '';
    //   this.verifyOTPFlag = 'false';
    // },
    validateForm2(scope) {
      this.$validator.validateAll(scope).then(async result => {
          let submitForm = true;
          if(this.UserOTP == '' && this.NdrOTPFlag == true){
            submitForm = false;
            let message = {
                title: 'Alert',
                body: `<p>You have not entered the NDR Code. <br/> Do you want to proceed without NDR Code? </p>`,
              };

              let res = await this.$dialog.confirm(message, {
                html: true,
                animation: 'bounce',
                backdropClose: true,
                okText: 'Yes',
                cancelText: 'No',
                reverse: true
              })
              .then(dialog => {
                submitForm = true;
              })
              .catch((e) => {
                submitForm = false;
                console.log('popup catch',e);
              })
          }

          if(result && this.isTripAllowedForSR == true) {
            this.isLoadingPrint = true;
            let isTripExist = await this.getExistingTripDetails();
            this.isLoadingPrint = false;
            if(isTripExist == false) {
              submitForm = false;
            }
          }
          if(this.PODImageShow == true){
            let uploadImg = await this.uploadFile();
            if(uploadImg == false) {
              submitForm = false;
            }
          }

          if(result && this.DeliveryStatus == 'XBU00219'){
            if(this.NDRSecurityCode != '' && this.NDRSecurityCode != 'null' && this.NDRSecurityCode != null && this.NDRSecurityCode != 'undefined'){
              if(this.NDRSecurityCode != this.deliveryCodeVerify){
                this.$refs.deliveryCodeVerify.focus()
                this.$alertify.error('Please enter valid delivery code.!');
                submitForm = false;
              }
            }
          }
          if(this.IsLongPinCode == false && this.DeliveryStatus == 'XBU00465'){
            this.$alertify.error('This pincode is not a long Pincode.');
            submitForm = false;
          }
        if (this.DBBPackingID!="" && this.DBBPackingID!=null && !this.checkBrandedPackagingIDFormatCheck(this.BPackingID)) {
          this.$alertify.error("Branded Packging ID is Required.");
          submitForm = false;
        }
          if(result && submitForm){
            this.isLoadingPrint = true;
            let getCrossBorder = await this.validateCrossBorderUser()
            let updatedata={
                isCrossBorderUserRequest: getCrossBorder,
                RunSheetId: this.RunSheetId,
                ShippingId: this.ShippingId.trim(),
                DeliveryUserName: this.getHubObj.DeliveryUsername,
                Status: this.DeliveryStatus,
                ReceiverName: this.ReceiverName,
                LastModifiedBy: this.localusermailid,
                DeliveryUserID: this.getHubObj.DeliveryUserID.toString(),
                DisputeStatusCode: this.DisputeStatus,
                StatusMarkedFrom: 'Web',
                RelationshipWithConsignee: this.ReceiverType == 0 ? 'Self' : this.RelationWithConsignee,
                IDProof: this.IDProof,
                IDProofNumber: this.IDProofNo,
                ReceiverMobileNo: this.ReceiverMobNo,
                ShipmentType: this.getHubObj.ShipmentType,
                IsPODMarkOnAlternetAddress: (this.PodMarkOnType == 1) ? true : false,
                EPaymentType: '',
                EPaymentName: '',
                Amount: this.NetPaymentReceived,
                IsOpenDelivery: this.IsOpenDelivery,
                IsCustomerSigned: false,
                DeviceCapturedDate: moment(this.dateobj.DeliveryDate).format('YYYY-MM-DD') + ' ' +this.dateobj.DeliveryTime+':00',
                IsSecurityCodeWrongAttempt: false,
                UserProcess: this.UserProcess,
                ProcessCode: this.DeliveryStatus,
                ReasonCode: this.DeliveryStatus,
                ShipmentStatus: this.getHubObj.ShipmentStatus,
                ClientID: this.ClientId,
                CurrentHubID: this.hubdetails,
                Latitude: 0,
                Longitude: 0,
                DeviceID: '',
                DeliveryDateTime: moment(this.dateobj.DeliveryDate).format('YYYY-MM-DD') + ' ' +this.dateobj.DeliveryTime+':00',
                ReAttemptDate: (this.dateobj.ReattemptDate) ? moment(this.dateobj.ReattemptDate).format('DD-MM-YYYY') : '',
                //ReAttemptDate: (this.dateobj.ReattemptDate) ? this.dateobj.ReattemptDate+' 00:00:00' : '',
                submitDistance: 0,
                PODPath: this.PODPath,
                OrderType: this.OrderType,
                OrderNo: this.OrderNo,
                DrsId: '',
                OldDeliveryUserOrUserId: "0",
                isOfflineSubmit: false,
                isTempNDR: this.nonVerifiedNDR,
                DisputeComment: this.DisputeComment,
                Flyerbarcode: '',
                IsAuthenticNDR: this.IsAuthenticNDR,
                NDRCodeComments: this.isShipmentOTP == true ? this.NDRCodeComments : 'Code not generated',
                Pincode: this.iswrongPincode,
                BPPackageID:this.BPackingID
            };
            updatedata.isTempNDR = updatedata.isTempNDR == 'true' ? true : false;
            //console.log('updatedata',updatedata);
            axios.post(apiUrl.api_url + 'expose/common/api/srrunsheet/pod',updatedata)
             .then((response) => {
                 if(response.data.code===200){
                   if(response.data.message == 'success') {
                     this.$alertify.success("Shipment Updated Successfully");

                     //tracker api called here
                     let TrackerInfo = {
                         projectname:"Last Mile",
                         type:"Web",
                         userid:this.localuserid,
                         username:this.localusermailid,
                         meta: {
                             "event":"shipmentmarkpod",
                             "shipment": this.ShippingId.trim().toString(),
                             "shipmentstatus": this.statusObj.text,
                             "srid": this.getHubObj.DeliveryUserID.toString(),
                             "DisputeStatusCode" : this.DisputeStatus,
                             "ReasonCode" : this.DeliveryStatus,
                         }
                     }
                     this.PageTracker(TrackerInfo);
                     //end tracker
                     this.clear();
                     this.ShippingId= '';
                   } else {
                     this.$alertify.error(response.data.message);
                   }
                 } else if(response.data.code===202){
                   this.$alertify.error(response.data.message);
                 } else{
                   this.$alertify.error("error while updating shipment status.");
                 }
                 this.isLoadingPrint = false;
             }).catch((httpException) => {
                 this.$alertify.error("error while updating shipment status.");
                 console.error('exception is:::::::::', httpException);
                 this.shippingDetailsShow = false;
                 this.isLoadingPrint = true;
             });
          }
      }).catch((error) => {
        console.log('errors exist', error)
      });
    },
    validateForm3(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          let delSubStatusArr = this.DeliverySubStatus.split('-');
          this.DisputeStatus = delSubStatusArr[0]
          this.DisputeComment = delSubStatusArr[1];
          this.IsOpenDeliveryModal=false;
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          let saveFlagTrigger = true;
          if(this.selectedShipmentData.length == 0){
            this.$alertify.error("Please select atleast one shipment");
            saveFlagTrigger = false;
          } else {

            let BulkForwardPayload = [];
            this.showForwardBulkReportStatus = {};
            this.isBulkShipmentListLoading = true;
            //let bulkPodPayload = {};

            $.each(this.selectedShipmentData, ( key, shippingId ) => {
              let matchObjfound = this.LatmileShipmentData.find(obj => obj.ShippingID == shippingId);

              let bulkPodPayload = {
                IDProofNumber: "",
                ReAttemptDate: "",
                LastModifiedBy: this.localusermailid,
                Latitude: 0,
                IsSecurityCodeWrongAttempt: false,
                IsPODMarkOnAlternetAddress: false,
                PODPath: "",
                EPaymentName: "",
                EPaymentType: "",
                ProcessCode: this.BulkDeliveryStatus,
                UserProcess: "",
                StatusMarkedFrom: "Web",
                IDProof: "",
                ReceiverMobileNo: "",
                DisputeStatusCode: this.BulkDisputeStatus !=null? this.BulkDisputeStatus :"",
                Longitude: 0,
                Amount: "",
                DeviceID: "",
                IsOpenDelivery: false,
                RelationshipWithConsignee: "",
                DeliveryUserName: matchObjfound.SRName,
                OldDeliveryUserOrUserId: 0,
                RunSheetId: matchObjfound.SRRunSheetId,
                IsCustomerSigned: false,
                DeviceCapturedDate: moment(this.dateobj.DeliveryDate).format('YYYY-MM-DD') + ' ' +this.dateobj.DeliveryTime+':00',
                submitDistance: 0,
                DisputeComment: "",
                OrderType: matchObjfound.OrderType,
                OrderNo: '',
                isOfflineSubmit: false,

              }

              bulkPodPayload.ShippingId = matchObjfound.ShippingID.trim();
              bulkPodPayload.Status = this.BulkDeliveryStatus;
              bulkPodPayload.ShipmentStatus = matchObjfound.ShipmentStatus;
              bulkPodPayload.ClientID = matchObjfound.ClientId;
              bulkPodPayload.DeliveryUserID = this.deliverUserName;
              bulkPodPayload.ReasonCode = this.BulkDeliveryStatus;
              bulkPodPayload.ReceiverName = '';
              bulkPodPayload.DeliveryDateTime = moment(this.dateobj.DeliveryDate).format('YYYY-MM-DD') + ' ' +this.dateobj.DeliveryTime+':00';
              bulkPodPayload.CurrentHubID = this.hubdetails;
              bulkPodPayload.ShipmentType = this.bulkShipmenttype;

              BulkForwardPayload.push(bulkPodPayload);
              console.log('shippingId',shippingId);
            });

            let setData = {};
            setData.podData = BulkForwardPayload;
            console.log('result',setData);

            axios
              .post(
                apiUrl.api_url + `expose/common/api/srrunsheet/bulk/pod`,
                setData
              )
              .then(response => {
                console.log('response',response);
                  if(response.data.code == 200 ) {
                    let TrackerInfo = {
                      projectname:"Last Mile",
                      type:"Web",
                      userid:this.localuserid,
                      username:this.localusermailid,
                      meta: {
                          "event":"bulkPod",
                          "shippingId" : this.ShippingId.trim().toString(),
                          "Status" : this.BulkDeliveryStatus,
                          "DeliveryUserID" : this.deliverUserName,
                          "ShipmentType" : this.bulkShipmenttype
                      }
                      }
                      this.PageTracker(TrackerInfo);
                  this.showForwardBulkReportStatus = response.data.data;
                  this.showForwardBulkModel = true;
                  this.bulkMiniClear();
                } else {
                  this.$alertify.error(response.data.message);
                }
                this.isBulkShipmentListLoading = false;
              })
              .catch(httpException => {
                this.$alertify.error("Failed to update.");
                this.isBulkShipmentListLoading = false;
                console.error("exception is:::::::::", httpException);
              });
          }
        }
      })
      .catch((error) => {
        console.log('error',error);
      })
    },
    SearchShipmets(scope) {
      this.$validator.validateAll(scope).then(result => {
        console.log('this.$validator',this.$validator);
        if(result){
          console.log('submit');
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    compare(a, b) {
      if (a.processcode < b.processcode)
          return -1;
      if (a.processcode > b.processcode)
          return 1;
      return 0;
    },
    GetStatusCode(shipmentType){
      return new Promise((resolve,reject) => {
          axios.post(apiUrl.api_url + 'external/getUserProcessMappingDetails',shipmentType)
           .then((statusList) => {

              (statusList.data.data).sort(this.compare);
              let statusListArr = [];
               if(statusList.data.code===200){
                 this.allStatusList = statusList.data.data;
                 for(var i= 0; i < statusList.data.data.length; i++){
                   if(this.AllowedNDRReasonsCodes != '') {
                      let isExist = this.AllowedNDRReasonsCodes.includes("XBU00219");
                      if(!isExist)
                        this.AllowedNDRReasonsCodes.push('XBU00219');
                     if(this.AllowedNDRReasonsCodes.includes(statusList.data.data[i].uniquecode)){

                       if(this.OrderType == 'COD' && (!['XBU00039','XBU00471'].includes(statusList.data.data[i].uniquecode))) {
                         statusListArr.push({'uniquecode':statusList.data.data[i].uniquecode,'userprocess':statusList.data.data[i].userprocess});
                       } else if(this.OrderType.toLowerCase() == 'prepaid' && (!['XBU00005','XBU00474'].includes(statusList.data.data[i].uniquecode))){
                         statusListArr.push({'uniquecode':statusList.data.data[i].uniquecode,'userprocess':statusList.data.data[i].userprocess});
                       }
                     }
                   } else {
                     if(this.OrderType == 'COD' && (!['XBU00039','XBU00471'].includes(statusList.data.data[i].uniquecode))) {
                       statusListArr.push({'uniquecode':statusList.data.data[i].uniquecode,'userprocess':statusList.data.data[i].userprocess});
                     } else if(this.OrderType.toLowerCase() == 'prepaid' && (!['XBU00005','XBU00474'].includes(statusList.data.data[i].uniquecode))){
                       statusListArr.push({'uniquecode':statusList.data.data[i].uniquecode,'userprocess':statusList.data.data[i].userprocess});
                     }
                   }
                   // BPPackingID set obj
                   if(statusList.data.data[i].uniquecode == "XBU00851"){
                    this.BPobj["value"] = statusList.data.data[i].uniquecode;
                    this.BPobj["text"] = statusList.data.data[i].uniquecode+" - "+ statusList.data.data[i].userprocess;
                    this.BPobj["IsAskNDROTP"] = statusList.data.data[i].ConfigSetting.IsAskNDROTP;
                  }
                 }

                 if(this.ClientBusinessDetailId == 7){
                   this.altCustomerDetailsShow = false;
                   this.podMarkOnShow = false;
                   this.PodMarkOnType = 0;

                   if(this.getHubObj.ShipAltAddress !='' && this.getHubObj.ShipAltPinCode == this.getHubObj.ShipPinCode && this.getHubObj.ShipAltPinCode != '') {
                     this.altCustomerDetailsShow = true;
                     this.podMarkOnShow = true;
                   }
                 } else {
                   this.podMarkOnShow = false;
                   this.PodMarkOnType = 0;
                   this.altCustomerDetailsShow = false;
                 }

                 resolve(statusListArr);//statusList.data.data;
               }
               else {
                   resolve(statusListArr)
               }
           })
           .catch((httpException) => {
               this.$alertify.error("User Process Mapping Not Found");
               let emptyArr = [];
               resolve(emptyArr)
               console.error('exception is:::::::::', httpException);
           });
      });
    },
    GetIDProofList(applicationType){
      return new Promise((resolve,reject) => {
        axios.post(apiUrl.api_url + 'external/getIDProofDetails',applicationType)
         .then((idProofList) => {
             if(idProofList.data.code===200){
               resolve(this.idProofListObj=idProofList.data.data);
             }
             else {
                 resolve(this.idProofListObj=[]);
             }
         })
         .catch((httpException) => {
             this.$alertify.error("ID Proof List Not Found");
             console.error('exception is:::::::::', httpException);
             resolve(this.idProofListObj=[]);
         });
      });
    },
    GetDisputeList(processCodeArr){
      return new Promise((resolve,reject) => {
        axios.post(apiUrl.api_url + 'external/getDisputeCodeDetails',processCodeArr)
         .then((disputeList) => {
             if(disputeList.data.code===200){
               resolve(this.disputeListObj=disputeList.data.data);
             }
             else {
                 resolve(this.disputeListObj=[]);
             }
         })
         .catch((httpException) => {
             this.$alertify.error("Disput Code List Not Found");
             console.error('exception is:::::::::', httpException);
             resolve(this.disputeListObj=[]);
         });
       });
    },
    GetConsigneeList(consigneePayload){
      return new Promise((resolve,reject) => {
        axios.post(apiUrl.api_url + 'expose/consignee/getconsignees',consigneePayload)
         .then((consigneeList) => {
             if(consigneeList.data.code===200){
                this.consigneeListObj=consigneeList.data.data;
                resolve(this.consigneeListObj)
             }
             else {
                resolve(this.consigneeListObj=[]);
             }
         })
         .catch((httpException) => {
             this.$alertify.error("Consignee List Not Found");
             console.error('exception is:::::::::', httpException);
             resolve(this.consigneeListObj=[]);s
         });
       });
    },
    changeDateFormat(){
      let current_datetime = new Date()
      this.dateobj.DeliveryTime = moment(current_datetime, 'YYYY-MM-DD').format('HH:mm');
    },
    onlyNumber($event){
       let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44) {
           $event.preventDefault();
        }
    },
    async checkStatusCode(obj){
      this.statusObj = obj;
      this.DeliveryStatus = obj.value;
      this.disputeDetailsShow = false;
      this.reattemptDeliveryDateShow = false;
      this.isDeliveryTypeOpen = false;
      this.DisputeStatus = '';
      this.iswrongPincode = '';
      let statusId = this.DeliveryStatus.toString();
      this.ReceiverName = ''

      //ndr code verification
      if(this.isShipmentOTP == true){
        if(statusId == 'XBU00327') {
          this.NdrOTPFlag = true;
          this.nonVerifiedNDR = 'true';
          this.IsAuthenticNDR = false;
          this.NDRCodeComments = 'Customer not willing to share the NDR code';
          //this.verifyOTPFlag = false
        } else {
          this.NdrOTPFlag = false;
          this.nonVerifiedNDR = 'false';
          this.NDRCodeComments = '';
          //this.verifyOTPFlag = 'true';
        }
      }

      this.UserOTP = '';
      this.deliveryCodeVerify = '';
      //new logic for dispute reasons
      let SubReasonObject = this.allStatusList.filter((statusCode)=>{
        return statusCode.uniquecode == statusId;
      })
      if(SubReasonObject.length > 0){
        if(SubReasonObject[0].hasSubStatus != undefined && SubReasonObject[0].hasSubStatus == true) {
          let key_generate = `${statusId}_deliverySubstatus`;
          this.disputeListObj = SubReasonObject[0][key_generate];
          this.disputeDetailsShow = true;
        }
      }
      //end

      if (statusId == 'XBU00023' || statusId == 'XBU00024' || statusId == 'XBU00327'){

        if(statusId == 'XBU00023') {
          this.processCodeArr = {
              processcode: 'P064'
          };
          // this.NdrOTPFlag = false;
          // this.verifyOTPFlag = 'true';
        } else if(statusId == 'XBU00024'){
          this.processCodeArr = {
              processcode: 'P048'
          };
          // this.NdrOTPFlag = false;
          // this.verifyOTPFlag = 'true';
        } else if(statusId == 'XBU00004' || statusId == 'XBU00327') {
          this.processCodeArr = {
              processcode: 'P071'
          };
        }
        //this.disputeListObj = await this.GetDisputeList(this.processCodeArr);
        this.disputeDetailsShow = true;
      }

      if (['XBU00469','XBU00008','XBU00326'].includes(statusId)){
        this.reattemptDeliveryDateShow = true;
      }
      if (statusId == 'XBU00219'){

        //NDR Code verify feature
        this.NdrOTPFlag = false;
        this.verifyOTPFlag = 'true';
        this.ReceiverName = this.getHubObj.ShipName
        if(this.IsOpenDelivery == 1 || this.IsOpenDelivery == true) {
          let message = {
            title: '',
            body: 'Is shipment opened for delivery?',
          };

          let res = this.$dialog.confirm(message, {
            animation: 'bounce',
            backdropClose: true,
            okText: 'No',
            cancelText: 'Yes',
          })
          .then(dialog => {
            this.IsOpenDeliveryModal = true;
            this.isDeliveryTypeOpen = true;
          })
          .catch(() => {
            this.PODImageShow = true;
          });
        }
        if(this.DeliveryType == 'PS' || this.DeliveryType == 'AS') {
          this.receiverTypeShow = true;
          if(this.DeliveryType == 'PS') {
            this.RelationWithConsigneeShow = false;
            this.ReceiverMobNoShow = false;
            this.IDProofListShow = true;
            this.IsReceiverNameDisabled = true;
          }

          if(this.DeliveryType == 'AS') {
            this.RelationWithConsigneeShow = false;
            this.ReceiverMobNoShow = false;
            this.IDProofListShow = false;
            this.IsReceiverNameDisabled = true;
          }

          if(this.ClientBusinessDetailId == 77 || this.ClientBusinessDetailId == 613 || this.ClientBusinessDetailId == 283) {
            this.receiverTypeShow = true;
          }

          if(this.ClientBusinessDetailId == 78) {
            this.receiverTypeShow = true;
            this.ReceiverType = 1;
            this.RelationWithConsigneeShow = true;
            this.ReceiverMobNoShow = true;

            if(this.DeliveryType == 'PS') {
              this.IDProofListShow = true;
              this.IsReceiverNameDisabled = false;
            }

            if(this.DeliveryType == 'AS') {
              this.IDProofListShow = true;
              this.IsReceiverNameDisabled = false;
            }
          }
        } else if(this.ClientBusinessDetailId == 7) {
          this.RelationWithConsigneeShow = false;
          this.IDProofListShow = true;
          this.ReceiverMobNoShow = false;
          this.receiverTypeShow = true;
          this.IsReceiverNameDisabled = true;

          if(this.getHubObj.ShipAltAddress !='' && this.getHubObj.ShipAltPinCode == this.getHubObj.ShipPinCode && this.getHubObj.ShipAltPinCode != '') {
            this.altCustomerDetailsShow = true;
            this.receiverTypeShow = true;
            this.IDProofListShow = true;
            this.podMarkOnShow = true;
          } else {
            this.receiverTypeShow = false;
            this.IDProofListShow = false;
            this.IsReceiverNameDisabled = true;
          }
        } else {
          this.receiverTypeShow = false;
          this.RelationWithConsigneeShow = false;
          this.ReceiverMobNoShow = false;
          this.IDProofListShow = false;
          this.ReceiverName = '';
        }
        this.checkReceiverType();
      } else {
        this.IsReceiverNameDisabled = true;
        this.receiverTypeShow = false;
        this.RelationWithConsigneeShow = false;
        this.ReceiverMobNoShow = false;
        this.IDProofListShow = false;
        this.ReceiverName = '';
        this.podMarkOnShow = false;
        this.altCustomerDetailsShow = false;
        this.PodMarkOnType = 0;
      }

      if (!['XBU00851'].includes(statusId) && this.DBBPackingID != this.BPackingID) {
        this.BPackingID = '';
      }
      if (['XBU00851'].includes(statusId) && this.DBBPackingID == this.BPackingID) {
        this.BPackingID = '';
      }
    },
    checkReceiverType(){
      let receiverVal = this.ReceiverType;
      if(receiverVal == 0) {
        if(this.DeliveryType == 'PS') {
          this.RelationWithConsigneeShow = false;
          this.ReceiverMobNoShow = false;
          this.IDProofListShow = true;
          this.IsReceiverNameDisabled = true;
        }

        if(this.DeliveryType == 'AS') {
          this.RelationWithConsigneeShow = false;
          this.ReceiverMobNoShow = false;
          this.IDProofListShow = false;
          this.IsReceiverNameDisabled = true;
        }

        if(this.ClientBusinessDetailId == 7) {
          this.RelationWithConsigneeShow = false;
          this.ReceiverMobNoShow = false;
          this.IsReceiverNameDisabled = true;
        }
        this.ReceiverName = this.getHubObj.ShipName
      }

      if(receiverVal == 1) {
        if(this.DeliveryType == 'PS') {
          this.RelationWithConsigneeShow = true;
          this.ReceiverMobNoShow = true;
          this.IDProofListShow = true;
          this.IsReceiverNameDisabled = false;
        }

        if(this.DeliveryType == 'AS') {
          this.RelationWithConsigneeShow = true;
          this.ReceiverMobNoShow = true;
          this.IDProofListShow = false;
          this.IsReceiverNameDisabled = false;
        }

        if(this.ClientBusinessDetailId == 7) {
          this.RelationWithConsigneeShow = false;
          this.ReceiverMobNoShow = true;
          this.IsReceiverNameDisabled = false;
        }
        this.ReceiverName = ''
      }
    },
    closeonPopup() {
      this.IsOpenDeliveryModal=false;
      this.$validator.reset();
      this.errors.clear();
    },
    uploadFile(){
      return new Promise((resolve, reject) => {
        //image upload code start here
        const formData = new FormData();
        formData.append('shippingId',this.ShippingId.trim());
        formData.append('file',this.file);
        let FilterExtention = ["image/jpeg", "image/jpg","image/png"];

        if(this.file.size >= 1024 * 1024 * 10){
          this.validated = true;
          this.$alertify.error("Please check image size should be less than 10MB ");
          const input = this.$refs.PODImage;
          input.type = 'text';
          input.type = 'file';
          this.validated = true;
          resolve(false);
        } else {
            if(!FilterExtention.includes(this.file.type)){
              this.removeFile();
              this.$alertify.error("Please upload only .jpg, .jpeg and .png files");
              resolve(false);
            }else{
            axios.post(apiUrl.api_url + 'webPODFileupload', formData)
             .then((response) => {
                 if(response.data.code === 200){
                   this.$alertify.success('uploaded Successfully');
                   this.PODPath = response.data.imageUrl;
                   this.removeFile();
                   resolve(true);
                 } else if(response.data.code === 202){
                   this.removeFile();
                   this.$alertify.error('Upload failed');
                   resolve(false);
                 } else {
                   this.$alertify.error(response.data.message);
                   resolve(false);
                 }
             })
             .catch((httpException) => {
               this.scanShipmentBatchFlag = false;
               this.$alertify.error("Unable to upload file");
               console.error('exception is:::::::::', httpException);
               resolve(false);
            })
          }
        }
      });
    },
    onuploadChange(event){
      const file = event.target.files[0];
      this.file = file;
      this.validated = false;
    },
    removeFile(){
      this.file = ''
      const input = this.$refs.PODImage;
      input.type = 'text';
      input.type = 'file';
      this.validated = true
    },
    resetForm(){
      this.ShippingId='';
      this.clear();
    },
    bulkClear(){
      this.deliverUserName = '';
      this.deliveryObj = {};
      this.BulkUpdateFlag = 0;
      this.bulkMiniClear();
    },
    bulkMiniClear(){
      let current_datetime = new Date()
      this.dateobj.DeliveryTime = moment(current_datetime, 'YYYY-MM-DD').format('HH:mm');
      this.dateobj.DeliveryDate = current_datetime;
      this.DeliveryStatus = '';
      this.BulkDeliveryStatus = '';
      this.selectedShipmentData = [];
      this.bulkDisputeDetailsShow = false;
      this.errors.clear();
      this.$validator.reset();
    },
    singlePODClear(){

    },
    clear(){
      let current_datetime = new Date()
      this.dateobj.DeliveryTime = moment(current_datetime, 'YYYY-MM-DD').format('HH:mm');
      //this.ShippingId='';
      this.getHubObj = [];
      this.dateobj.DeliveryDate = current_datetime;
      this.DeliveryStatus = '';
      this.statusListObj = [];
      this.DisputeStatus = '';
      this.disputeListObj = [];
      this.ReceiverType = 0;
      this.PodMarkOnType = 0;
      this.ReceiverMobNo = '';
      this.ReceiverName = '';
      this.NetPaymentReceived = '';
      this.RelationWithConsignee = '';
      this.consigneeListObj = [];
      this.IDProof = '';
      this.idProofListObj = [];
      this.IDProofNo = '';
      this.dateobj.ReattemptDate = '';
      this.DeliverySubStatus = '';
      this.AllowedNDRReasonsCodes = [];
      this.removeFile();
      this.errors.clear();
      this.$validator.reset();
      this.shippingDetailsShow = false;
      this.RunSheetId = '',
      this.nonVerifiedNDR =  'false';
      this.UserOTP = '';
      this.verifyOTPFlag = 'true';
      this.isShipmentOTP = false;
      this.statusObj = {};
      this.IsAuthenticNDR = false;
      this.NDRCodeComments = '';
      this.iswrongPincode = '';
      this.IsLongPinCode = true;
      this.BPackingID='';
      this.DBBPackingID='';
      this.BPobj={};
    },
    getExistingTripDetails(){
      return new Promise((resolve, reject) => {
        let tripPayload = {
          "XBkey":"XB123",
          "HubId":this.hubdetails,
          "DeliveryUserId":this.getHubObj.DeliveryUserID.toString()
        }
        axios.post(apiUrl.api_url + 'expose/trip/tripDetails', tripPayload)
         .then((response) => {
           if(response.data.TripState == 'created') {
             this.$alertify.error('Trip not started for SR. Please start trip from SR app.');
             resolve(false);
           } else {
             resolve(true);
           }
         })
         .catch((httpException) => {
           this.$alertify.error("Not getting any response message");
           console.error('exception is:::::::::', httpException);
           resolve(false);
        })
      });
    },
    ValidateBrandedPkgId(){
      let inputBPackingID = this.BPackingID.trim().toLowerCase();
      let DBBPackingID = this.DBBPackingID.trim().toLowerCase();
      if(inputBPackingID !=""){
        if(inputBPackingID != DBBPackingID){
          if (this.noofbpscansallowed > 1 && this.isAllowManualEntryBP != '1') {
            this.noofbpscansallowed--;
            let message = 'Wrong Branded Packging id is Scanned. ' + this.noofbpscansallowed + ' Attempts Left';
            this.$alertify.error(message);
          } else if (this.noofbpscansallowed <= 1 && this.isAllowManualEntryBP == '0'){
            this.validateForm2('form-2');
          }
          this.checkStatusCode(this.BPobj);
        }
        else{
          if(this.DeliveryStatus.toString() == "XBU00851"){
            this.checkStatusCode("");
          }
        }
      }else{
        if(this.DeliveryStatus.toString() == "XBU00851"){
          this.checkStatusCode("");
        }
      }    
    },
    handleDragOver(event){
      event.preventDefault();
    },
    oncallImediate(keycode) {
      if ($("#BPackingID").val() == '') {
        this.keyFiredCount.value = 0;
        return false;
      }
      if (this.keyFiredCount.value <= 1 && keycode == 13) {
        this.Ismannual = false;
        this.keyFiredCount.value = 0;
      } else {
        if (this.isAllowManualEntryBP == '0') {
          this.$alertify.error('Manual input branded Packging is not allowed. Please use barcode scanner');
          this.BPackingID = '';
          return false;
        }
        console.log('User Input detection .!');
        this.Ismannual = true;
      }
    },
    DelayExecution(f, delay) {
      var timer = null;
      return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
            f.apply(context, args);
        },
        delay || 100);
      };
    },
    KeyHandle() {
      const vm = this;
      $("#BPackingID").keyup(this.DelayExecution(function (event) {
        this.Ismannual = true;
        let keycode = (event.keyCode ? event.keyCode : event.which);
        vm.keyFiredCount.value = vm.keyFiredCount.value + 1;
        vm.oncallImediate(keycode);
        vm.setIsMannual();
      }));
    },
    setIsMannual(){
      if(this.BPackingID == '' ) {
        this.Ismannual = false;
      }
    },
    isLetterOrNumber($event) {
      let char = String.fromCharCode($event.keyCode);
      if (/^[A-Za-z0-9]+$/.test(char)) return true;
      else $event.preventDefault();
    },
    checkBrandedPackagingIDFormatCheck(bpid) {
      if(bpid.match("[a-zA-Z0-9]")){
        return true;
     } else {
        return false;
      }
    },
  },
}


Validator.extend('isDeliveryCodeMax', {
  getMessage: field => "Please enter max 6 digit delivery code number.!",
  validate: value => {

      let DeliveryCodeValidDigit = $("#deliveryCodeVerify").val();
      if(isNaN(DeliveryCodeValidDigit) || (DeliveryCodeValidDigit.length <= 6)) {
        return true
      } else {
        return false
      }
  }
});

//extended validation
Validator.extend('isValidNumber', {
  getMessage: field => 'Please Enter only number.!',
  validate: value => {
    console.log('success');
    let numberRegex = /^[0-9]+$/;
    if(numberRegex.test(value) == true){
      return true;
    } else {
      return false;
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/components/SetShipmentStatus/SetShipmentStatus.component.js